<script>
import { storagePath } from '@/shared/js/utils/index'

// X (formerly Twitter) retired its brand mark from the `hf` icon font — the font's own
// `.hf-x` glyph is the unrelated close/cross "✕" used for menu-close, not the X logo.
// Sourced from the brand SVG at src/assets/icons/x.svg; inlined here (rather than
// loaded as an asset URL) so it can inherit text color via `fill="currentColor"`.
const X_ICON_PATH = 'M818 800 498.11 333.745l.546.437L787.084 0h-96.385L455.738 272 269.15 0H16.367l298.648 435.31-.036-.037L0 800h96.385l261.222-302.618L565.217 800zM230.96 72.727l448.827 654.546h-76.38L154.217 72.727z'

/**
 * Generates an Hypefactors Icon
 * @module VIcon
 */
export default {
  name: 'VIcon',
  functional: true,
  props: {
    type: {
      type: String,
      required: true
    },
    even: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: ''
    },
    fallback: {
      type: Boolean,
      default: false
    }
  },
  render: (h, { data, props, parent }) => {
    if (props.type === 'twitter' && !props.fallback) {
      return h('svg', {
        ...data,
        attrs: {
          ...data.attrs,
          viewBox: '0 0 1024 1024',
          fill: 'currentColor',
          'fill-rule': 'evenodd'
        },
        class: [
          'hf',
          'v-icon-svg',
          data.class,
          data.staticClass,
          {
            'hf-fw': props.even,
            ['hf-' + props.size]: props.size
          }
        ]
      }, [
        h('path', { attrs: { d: X_ICON_PATH, transform: 'translate(103 112)' } })
      ])
    }

    const icon = h('i', {
      ...data,
      class: [
        'hf',
        data.class,
        data.staticClass,
        {
          'hf-fw': props.even,
          ['hf-' + props.size]: props.size,
          ['hf-' + props.type]: props.type
        }
      ]
    })

    const imageSrc = storagePath('/images/icons/hf_font/' + props.type + '.svg')
    const image = h('img', {
      ...data,
      attrs: { ...data.attrs, src: imageSrc },
      class: [
        'v-icon-fallback',
        data.class
      ]
    })

    return props.fallback ? image : icon
  }
}
</script>

<style>
/* SVG counterpart of the `.hf` font icon sizing (twitter/X only — see render() above).
   Mirrors hf-fw's fixed-width box; height stays 1em so hf-{size} (font-size-based) scales
   it the same way a glyph would. */
.v-icon-svg {
  height: 1em;
  vertical-align: -0.125em;
}

.v-icon-svg:not(.hf-fw) {
  width: 1em;
}
</style>
